export const trackingEvents = {
  BULK_CANCEL_BOOKING: {
    SAVE: {
      CLICKED: 'bulk_cancel_booking.save.clicked',
    },
    SPOT_DECISION: {
      SELECTED: 'bulk_cancel_booking.spot_decision.selected',
    },
  },
}
